<template>
	<ProcessCreatePage>
		<Header :title="isNewCase ? this.$t('new_damage_case_message_lawyer').toString() : this.$t('generate_form_message_lawyer').toString()">
			<p>
				{{ $t('share_important_data_with_lawyer') }}
			</p>
		</Header>

		<div class="main">
			<BaseTextarea
				ref="accident_description"
				v-model="accident_description"
				:error-message="$t('enter_accident_description')"
				:label="$t('accident_occurred_as_follows_input')"
				:placeholder="$t('accident_description')"
			/>

			<BaseInput
				ref="vehicle_owner"
				v-model="vehicle_owner"
				:error-message="$t('enter_vehicle_owner')"
				:label="$t('client_not_vehicle_owner_input')"
				:placeholder="$t('vehicleowner')"
			/>

			<BaseTextarea
				ref="note"
				v-model="note"
				:error-message="$t('enter_notes')"
				:label="$t('additional_notes_repair_shop_to_lawyer_input')"
				:placeholder="$t('hints')"
			/>

			<div class="flex space-x-12 w-full">
				<BaseRadioForm
					ref="BaseRadioForm.BaseRadioForm"
					:options="contactOptions"
					v-model="contactOption"
					:label="$t('customer_prefers_contact_via_input')"
					:error-message="$t('required_value')"
					:required="true"
					class="w-96 flex-shrink-0"
				>
					<template #[`input_E-Mail`]>
						<EMailInput
							ref="email"
							class="w-full"
							v-model="email"
							:required="true"
							:error-message="$t('e_mail_not_valid')"
							:label="$t('e_mail')"
							:placeholder="$t('e_mail')"
							v-if="contactOption === contactOptions[0].value"
						/>
					</template>
				</BaseRadioForm>
			</div>
		</div>

		<Footer :is-skippable="false" @backButtonClick="$emit('previous', $event)" @continueButtonClick="continueButtonClick($event)" />
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import Validate from '@/mixins/Validate';
import BaseTextarea from '@/components/forms/inputs/BaseTextarea';
import EMailInput from '@/components/forms/inputs/EMailInput';
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseRadioForm from '@/components/forms/inputs/BaseRadioForm';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'MailToLawyer',
	components: { ProcessCreatePage, BaseRadioForm, BaseInput, EMailInput, BaseTextarea, Header, Footer },
	mixins: [Validate, Authentication],
	props: {
		apiData: {},
		isNewCase: { default: true },
	},
	data() {
		return {
			contactOption: null,
			accident_description: '',
			vehicle_owner: '',
			email: '',
			note: '',
			contact_via: '',
		};
	},
	computed: {
		contactOptions() {
			return [
				{ display: this.$t('e_mail'), value: 'E-Mail', inputType: 'text' },
				{ display: this.$t('postal'), value: 'Post' },
			];
		},
	},
	methods: {
		continueButtonClick: function($event) {
			if (this.validate()) {
				this.$emit('next', {
					mailToLawyer: {
						accident_description: this.accident_description,
						vehicle_owner: this.vehicle_owner,
						email: this.contactOption === 'E-Mail' ? this.email : '',
						note: this.note,
						contact_via: this.contactOption,
					},
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	watch: {
		'apiData.customer.email'() {
			if (!this.email && this.apiData.customer.email) {
				this.email = this.apiData.customer.email;
			}
		},
	},
};
</script>

<style scoped></style>
